import {Component, OnInit, Input} from '@angular/core';
import {PostService} from "../../../../service/forum/post.service";
import {Router, ActivatedRoute} from "@angular/router";
import {Post} from "../../../../domain/post";
import {Topic} from "../../../../domain/topic";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {TopicService} from "../../../../service/forum/topic.service";
import {routerTransitionSlideFromRight} from "../../../../animations/router.animations";


@Component({
    selector: 'app-post-list',
    templateUrl: './post-list.component.html',
    styleUrls: ['./post-list.component.scss'],
    providers: [PostService, TopicService],
    animations:  [ routerTransitionSlideFromRight() ],
    host: {'[@routerTransition]': ''}

})
export class PostListComponent implements OnInit {

    public listTitle = 'Ultimas novedades';
    public posts: Post[] = [];
    public filtered = false;
    public topic: Topic;
    public $topic: BehaviorSubject<Topic> = new BehaviorSubject(null);


    constructor(private postService: PostService,
                private router: Router,
                private route: ActivatedRoute) {
    }

    ngOnInit() {

        this.$topic.filter( t => t == null)
            .switchMap(id => this.postService.findLastPosts() )
            .subscribe(p => {
                this.listTitle = 'Ultimas novedades';
                this.filtered = false;
                this.posts = p;

            } );

        this.$topic.filter( t => t != null)
            .do(t => this.topic = t )
            .switchMap(t => this.postService.findByTopic(this.topic) )
            .subscribe(p => {
                this.listTitle = this.topic.name;
                this.filtered = false;
                this.posts = p;

            } );

    }

    public goToPost(p : Post){
        this.router.navigate(["home", "post", p.id]);
    }

    public refreshPosts(t : Topic) {
        this.$topic.next(t);
    }

    addPost(){
        this.router.navigate(["home","post","new","edit"]);
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/post/post-list/post-list.component.ts